export { type BorderUsDocumentConfig, BorderUsDocumentConfigSchema } from "~/shared/documents/schemas/border-us-config.schema";
